import React, { useState } from "react";
import { Box, Typography, Stack } from "@mui/material";
import TextInput from "../../components/textInput";
import CustomButton from "../../components/customButton";
import { openSnackAlert } from "../../helper";
import { changeAdminPassword } from "../../services/Auth";
import AppLoader from "../../components/appLoader";

const ChangePassword = () => {
  const [inputVal, setInputVal] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setInputVal({
      ...inputVal,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    if (!inputVal.oldPassword)
      return openSnackAlert("Current password is required", "error");
    else if (!inputVal.newPassword)
      return openSnackAlert("New password is required", "error");
    else if (!inputVal.confirmPassword)
      return openSnackAlert("Confirm password is required", "error");
    else if (inputVal.newPassword !== inputVal.confirmPassword)
      return openSnackAlert("Passwords do not match", "error");
    else {
      try {
        setIsLoading(true);
        const payload = {
          oldPassword: inputVal.oldPassword,
          newPassword: inputVal.newPassword,
        };
        const response = await changeAdminPassword(payload);
        const resData = response?.data;

        if (resData?.status === "success") {
          openSnackAlert(resData?.message, "success");
          setInputVal({
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
          });
        } else {
          openSnackAlert(resData?.message || "Change password failed", "error");
        }
      } catch (error) {
        setIsLoading(false);
        console.error(error);
        openSnackAlert(error?.message || "Something went wrong", "error");
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <Box borderRadius={"22px"} mt={4}>
      <AppLoader isVisible={isLoading} />
      <Typography fontWeight={600} fontSize={18} mb={2}>
        Change Password
      </Typography>

      <Stack spacing={2}>
        <TextInput
          label="Current Password"
          placeholder="Enter current password"
          type="password"
          borderColor="#706f6f"
          name="oldPassword"
          value={inputVal.oldPassword}
          onChange={handleChange}
          showPassIcon
          inputBgColor={"#fff"}
        />

        <TextInput
          label="New Password"
          placeholder="Enter new password"
          type="password"
          borderColor="#706f6f"
          name="newPassword"
          value={inputVal.newPassword}
          onChange={handleChange}
          showPassIcon
          inputBgColor={"#fff"}
        />

        <TextInput
          label="Confirm New Password"
          placeholder="Re-enter new password"
          type="password"
          name="confirmPassword"
          borderColor="#706f6f"
          inputBgColor={"#fff"}
          value={inputVal.confirmPassword}
          onChange={handleChange}
          showPassIcon
        />

        <CustomButton
          btnLabel={"Change Password"}
          variant={"webbutton"}
          handlePressBtn={handleSubmit}
        />
      </Stack>
    </Box>
  );
};

export default ChangePassword;
